import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import {
    Calendar,
    Clock,
    MapPin,
    MoreHorizontal,
    Plus,
} from 'lucide-react';

export default function Events() {
    const [selectedStandard, setSelectedStandard] = useState('Standard - 8');
    const [selectedDivision, setSelectedDivision] = useState('Division - C');

    const eventsData = [
        { id: 1, title: 'Annual Science Fair', date: 'March 15, 2026', time: '10:00 AM - 04:00 PM', location: 'Main Auditorium', category: 'Academic' },
        { id: 2, title: 'Parent-Teacher Meeting', date: 'March 20, 2026', time: '09:00 AM - 01:00 PM', location: 'Classroom Block A', category: 'Administrative' },
        { id: 3, title: 'Inter-School Sports Meet', date: 'March 25, 2026', time: '08:00 AM - 06:00 PM', location: 'School Ground', category: 'Sports' },
        { id: 4, title: 'Spring Music Festival', date: 'April 05, 2026', time: '05:00 PM - 09:00 PM', location: 'Open Air Theater', category: 'Cultural' }
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <Sidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="School Events"
                    subtitle="Stay updated with academic and extracurricular activities"
                    showStandardSelector={true}
                    showDivisionSelector={true}
                    selectedStandard={selectedStandard}
                    selectedDivision={selectedDivision}
                    setSelectedStandard={setSelectedStandard}
                    setSelectedDivision={setSelectedDivision}
                >
                    <button className="flex items-center gap-3 py-2.5 px-6 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        Event
                    </button>
                </Header>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-8 mb-10">
                    {eventsData.map((event) => (
                        <div key={event.id} className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8 hover:scale-[1.01] transition-all group relative overflow-hidden">
                            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-50/50 rounded-bl-[100px] -mr-8 -mt-8 -z-0 transition-all group-hover:bg-blue-100/50"></div>

                            <div className="relative z-10">
                                <span className={`px-4 py-1.5 rounded-full text-[12px] font-black tracking-widest uppercase mb-6 inline-block ${event.category === 'Academic' ? 'bg-blue-50 text-blue-500' :
                                    event.category === 'Administrative' ? 'bg-amber-50 text-amber-500' :
                                        event.category === 'Sports' ? 'bg-emerald-50 text-emerald-500' :
                                            'bg-rose-50 text-rose-500'
                                    }`}>
                                    {event.category}
                                </span>

                                <h3 className="text-[24px] font-black text-[#111827] mb-6 group-hover:text-blue-500 transition-colors leading-tight">{event.title}</h3>

                                <div className="space-y-4">
                                    <div className="flex items-center gap-3 text-gray-500 font-bold text-[15px]">
                                        <Calendar size={18} className="text-blue-500" />
                                        {event.date}
                                    </div>
                                    <div className="flex items-center gap-3 text-gray-500 font-bold text-[15px]">
                                        <Clock size={18} className="text-blue-500" />
                                        {event.time}
                                    </div>
                                    <div className="flex items-center gap-3 text-gray-500 font-bold text-[15px]">
                                        <MapPin size={18} className="text-blue-500" />
                                        {event.location}
                                    </div>
                                </div>

                                <div className="mt-10 flex items-center justify-between pt-6 border-t border-gray-50">
                                    <button className="text-[14px] font-black text-blue-500 hover:underline">View details</button>
                                    <button className="p-2 text-gray-400 hover:text-gray-900 transition-colors">
                                        <MoreHorizontal size={20} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </main>
        </div>
    );
}
